import "./MarketingSubfooter.css";
import React from "react";
import MarketingCarousel from "./MarketingCarousel";
import ContentItem from "shared/components/cms/ContentItem";
import concat from "lodash/concat";
import slice from "lodash/slice";
import map from "lodash/map";

const CAROUSEL_LEGAL_KEYS = [
    "csuLegalText",
    "slpLegalText",
    "fincoreLegalText"
];

export default ({ defaultProduct, legalTextKeys, requestInfoUrl }) => {
    const legalText = map(legalTextKeys, (contentKey, index) =>
        <ContentItem tag="li" contentKey={contentKey} key={`legal-${index}`} />);
    const carouselText = map(CAROUSEL_LEGAL_KEYS, (contentKey, index) =>
        <ContentItem tag="li" sharedKey="marketing2020/carouselLegalText" contentKey={contentKey} key={`carousel-${index}`} />);

    const disclaimers = concat(legalText, carouselText);
    const leftColumnCount = Math.ceil(disclaimers.length / 2);

    return (
        <div className="marketing-subfooter">
            <img className="background-chevron" alt="background" src={require("../assets/redesign2020/top-background.svg")} />
            <MarketingCarousel defaultProduct={defaultProduct} carouselLegalSuperScript={legalTextKeys.length + 1} />
            <div className="marketing-subfooter-body">
                <img alt={"chevron"} className="chevron" src={require("../assets/redesign2020/chevron.svg")} />
                <h3 className="subfooter-header">Ready to make an impact on your employees' financial well-being and your company's bottom line?</h3>
                <a href={requestInfoUrl} className="button" target="_blank">Request a demo</a>
            </div>
            <div className="legalTextWrapper">
                <div className="legalText">
                    <ol className="legalTextList">
                        {slice(disclaimers, 0, leftColumnCount)}
                    </ol>
                    <ol className="legalTextList" start={leftColumnCount + 1}>
                        {slice(disclaimers, leftColumnCount)}
                    </ol>
                </div>
            </div>
        </div>
    );
};